import { Component } from '@angular/core';
import { UserDataService } from '../services/user-data-service';

@Component({
    selector: 'app-devsettings',
    templateUrl: './devsettings.component.html',
    styleUrls: ['./devsettings.component.css'],
    standalone: false
})
export class DevsettingsComponent {

  constructor(
    private userData: UserDataService){}
    
  clear(){
    this.userData.clear();
    //console.log("clear storage");
  }
  getSelectedRefineryDetails(){
    //console.log(this.userData.getSelectedRefineryDetails());
  }
  getSelectedNodeDetails(){
    //console.log(this.userData.getSelectedNodeDetails());
  }
  getSelectedConfigJson(){
    //console.log(this.userData.getSelectedConfigJson());
  }
  getSelectedTabIndex(){
    //console.log(this.userData.getSelectedTabIndex());
  }
  getNodeParentDataLine(){
    //console.log(this.userData.getNodeParentDataLine());
  }
  getNodeAttributionLine(){
    //console.log(this.userData.getNodeAttributionLine());
  }
  getMasterNodeBoxTypes(){
    //console.log(this.userData.getMasterNodeBoxTypes());
  }
  getMasterTransformers(){
    //console.log(this.userData.getMasterTransformers());
  }
  getMasterFarmtypes(){
    //console.log(this.userData.getMasterFarmtypes());
  }
}
